import React from 'react';

export default function LayoutMap(props) {
  const { children } = props;

  return <div>{children}</div>;
}
